import styled from 'styled-components';

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--space-xxs);
  margin-bottom: var(--space-m);

  label {
    display: flex;
    align-items: center;
    gap: var(--space-xxs);

    color: var(--grey6);
    font-size: 0.9rem;
    font-weight: 800;
  }

  input,
  textarea,
  select {
    width: 100%;
    max-width: 100%;
    min-width: 100%;

    padding: var(--space-s) var(--space-m);

    border: 1px solid var(--grey1);
    border-radius: var(--borderRadius);

    background: var(--white);
    color: var(--grey7);

    font-size: 1rem;
    font-family: inherit;

    transition:
      border-color 0.2s ease,
      box-shadow 0.2s ease;
  }

  textarea {
    min-height: 130px;
    resize: vertical;
    line-height: 1.5;
  }

  input:hover,
  textarea:hover,
  select:hover {
    border-color: var(--grey2);
  }
  select {
    appearance: none;
    cursor: pointer;
  }
  select {
    background-image: url('data:image/svg+xml,%3Csvg...');
    background-repeat: no-repeat;
    background-position: right 16px center;
  }

  input:focus,
  textarea:focus,
  select:focus {
    outline: none;
    border-color: var(--orange4);
    box-shadow: 0 0 0 4px rgba(242, 175, 23, 0.12);
  }

  .detail {
    color: var(--grey3);
    font-size: 0.82rem;
    line-height: 1.5;
    font-weight: 500;
  }
`;

export const CheckboxFieldContainer = styled.label`
  min-width: 100%;
  margin-block: var(--space-m);
  display: flex;
  align-items: flex-start;
  gap: var(--space-s);

  padding: var(--space-m);

  border: 1px solid var(--grey1);
  border-radius: var(--borderRadius);

  background: var(--white);

  cursor: pointer;

  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;

  &:hover {
    border-color: var(--grey2);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }

  input {
    margin-top: 0.2rem;
    width: 18px;
    height: 18px;
    accent-color: var(--orange4);
    cursor: pointer;
    flex-shrink: 0;
  }

  .checkboxContent {
    display: flex;
    flex-direction: column;
    gap: var(--space-xxs);
  }

  .checkboxTitle {
    color: var(--grey7);
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.3;
  }

  .checkboxDescription {
    color: var(--grey4);
    font-size: 0.85rem;
    line-height: 1.5;
  }
`;
